import SectionHeader from "../ui/SectionHeader";
import MiniBar from "../ui/MiniBar";
import { fmt } from "../../formatters";
import { FONT, COLORS } from "../../styles";

export default function CashflowTab({ analysis, transactions }) {
  const { monthly } = analysis;
  const last30 = [...new Map(
    transactions.filter((t) => { const d = new Date(); d.setDate(d.getDate() - 30); return t.date >= d.toISOString().split("T")[0]; }).map((t) => [t.date, t])
  ).values()].sort((a, b) => a.date.localeCompare(b.date));
  const maxBal = Math.max(...last30.map((t) => t.balance), 1);

  return (
    <div>
      <SectionHeader title="30-Day Cash Flow Breakdown" />
      <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 16, marginBottom: 24 }}>
        <div style={{ background: COLORS.card, border: `1px solid ${COLORS.border}`, borderRadius: 10, padding: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.04)" }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: COLORS.muted, marginBottom: 16, fontFamily: FONT }}>Daily Balance (30 days)</div>
          <div style={{ display: "flex", alignItems: "flex-end", gap: 3, height: 120 }}>
            {last30.map((t, i) => (
              <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div style={{ width: "100%", height: `${(t.balance / maxBal) * 100}px`, background: t.balance < 5000 ? COLORS.red : t.balance < 15000 ? COLORS.orange : COLORS.primary, borderRadius: "2px 2px 0 0", minHeight: 2, opacity: 0.7, transition: "height 0.5s ease" }} title={`${t.date}: ${fmt(t.balance)}`} />
              </div>
            ))}
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8 }}>
            <span style={{ fontSize: 11, color: COLORS.dim }}>30 days ago</span>
            <span style={{ fontSize: 11, color: COLORS.dim }}>Today</span>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {[
            { label: "Revenue", val: monthly.totalCredits, max: monthly.totalCredits, color: COLORS.green },
            { label: "Ops Debits", val: monthly.totalDebits, max: monthly.totalCredits, color: COLORS.orange },
            { label: "Loan Payments", val: monthly.loanPayments, max: monthly.totalCredits, color: COLORS.red },
            { label: "Net", val: monthly.totalCredits - monthly.totalDebits - monthly.loanPayments, max: monthly.totalCredits, color: COLORS.blue },
          ].map(({ label, val, max, color }) => (
            <div key={label} style={{ background: COLORS.card, border: `1px solid ${COLORS.border}`, borderRadius: 10, padding: 14, boxShadow: "0 1px 3px rgba(0,0,0,0.04)" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span style={{ fontSize: 12, color: COLORS.muted, fontFamily: FONT }}>{label}</span>
                <span style={{ fontSize: 14, color, fontWeight: 700, fontFamily: FONT }}>{fmt(val)}</span>
              </div>
              <MiniBar pct={(val / max) * 100} color={color} />
            </div>
          ))}
        </div>
      </div>
      <SectionHeader title="Weekly Breakdown" />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 12 }}>
        {[1, 2, 3, 4].map((week) => {
          const wStart = new Date(); wStart.setDate(wStart.getDate() - (week * 7));
          const wEnd = new Date(); wEnd.setDate(wEnd.getDate() - ((week - 1) * 7));
          const wTxns = transactions.filter((t) => t.date >= wStart.toISOString().split("T")[0] && t.date < wEnd.toISOString().split("T")[0]);
          const creds = wTxns.filter((t) => t.type === "credit" && !t.isLoan).reduce((s, t) => s + t.amount, 0);
          const debs = Math.abs(wTxns.filter((t) => t.type === "debit" && !t.isLoan).reduce((s, t) => s + t.amount, 0));
          const loans = Math.abs(wTxns.filter((t) => t.isLoan && t.type === "debit").reduce((s, t) => s + t.amount, 0));
          return (
            <div key={week} style={{ background: COLORS.card, border: `1px solid ${COLORS.border}`, borderRadius: 10, padding: 14, boxShadow: "0 1px 3px rgba(0,0,0,0.04)" }}>
              <div style={{ fontSize: 11, color: COLORS.dim, fontWeight: 600, marginBottom: 10, fontFamily: FONT }}>Week -{week}</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <div><div style={{ fontSize: 11, color: COLORS.dim }}>Credits</div><div style={{ fontSize: 16, color: COLORS.green, fontWeight: 700, fontFamily: FONT }}>{fmt(creds)}</div></div>
                <div><div style={{ fontSize: 11, color: COLORS.dim }}>Debits</div><div style={{ fontSize: 16, color: COLORS.orange, fontWeight: 700, fontFamily: FONT }}>{fmt(debs)}</div></div>
                <div><div style={{ fontSize: 11, color: COLORS.dim }}>Loan Pmts</div><div style={{ fontSize: 16, color: COLORS.red, fontWeight: 700, fontFamily: FONT }}>{fmt(loans)}</div></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
